import { jsx } from 'react/jsx-runtime';
import { StandardTileImage, SquareImageContainer } from '@vp/swan';
import 'react';
import { ProductImage } from '../../../../@core/components/ui/product-image/ProductImage.js';

const ProductImagePreview=({item})=>{return jsx(StandardTileImage,{"data-cy":"product-item-image-preview",children:jsx(SquareImageContainer,{"data-cy":"product-item-square-image-container",children:jsx(ProductImage,{item:item,priority:"purcs"})})})};

export { ProductImagePreview };
//# sourceMappingURL=ProductImagePreview.js.map
